import { SizeType } from 'antd/lib/config-provider/SizeContext';
import styled from 'styled-components';

import { BodilColor, inputWidth } from '~src/branding';
import { inputAddressHouseSize, inputSizeStyleAddress } from '~src/branding';
import { boxShadows } from '~src/branding/boxShadow';
import { useDisplayContext } from '~src/context/DisplayContext';
import { InputSize } from '~src/model/input';

import { textStyle } from '../Typography';

export const Container = styled.div<{ inputSize?: InputSize | null }>(({ inputSize }) => ({
  position: 'relative',
  margin: '0 auto',
  width: `${inputSize ? inputWidth(inputSize) : '100%'}`,
}));

export const SuggestionContainer = styled.div({
  position: 'absolute',
  display: 'flex',
  flexFlow: 'column wrap',
  background: BodilColor.base.white,
  width: '100%',
  padding: '8px 12px 8px 8px',
  borderRadius: '4px',
  border: `1px solid ${BodilColor.greyscale[10]}`,
  marginTop: '4px',
  zIndex: 1000,
});

export const Suggestion = styled.div<{ hovered?: boolean }>(({ hovered }) => ({
  zIndex: 1000,
  width: `100%`,
  height: '100%',
  padding: '12px',
  borderRadius: '8px',
  backgroundColor: hovered ? BodilColor.ui.action.default : 'transparent',
  color: hovered ? BodilColor.base.white : 'inherit',
  cursor: 'pointer',
  ':hover': {
    backgroundColor: BodilColor.ui.action.default,
    color: BodilColor.base.white,
  },
  '&:not(:first-child)': {
    marginTop: '-1px',
  },
}));

export const AddressInputWrapper = styled.div<{ size?: SizeType }>(({ size }) => {
  const { isMobile } = useDisplayContext();
  const { height, width } = inputSizeStyleAddress(size);
  const houseSize = inputAddressHouseSize(size);

  const fontStyle = textStyle(2, isMobile);
  const shadowStyle = isMobile ? boxShadows.mobileBodil : {};

  return {
    width: isMobile ? '100%' : width,
    position: 'relative',
    maxWidth: '100%',
    '.ant-select-single:not(.ant-select-customize-input) .ant-select-selector': {
      height,
      ...fontStyle,
      borderRadius: isMobile ? '32px' : '4px',
      ...shadowStyle,
    },
    '.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input': {
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      left: `calc(${houseSize} +  ${isMobile ? houseSize : '7px'})`,
      width: '85%',
    },
    '.ant-select-selection-placeholder': {
      marginLeft: `calc(${houseSize} + ${isMobile ? houseSize : '7px'})`,
      alignSelf: 'center',
    },
  };
});
